(function () {
  'use strict';

  var root = document.querySelector('[data-ezl-pdp]');
  if (!root) return;
  var list = function (selector, scope) { return Array.prototype.slice.call((scope || root).querySelectorAll(selector)); };

  // Gallery: thumbnails swap the main photo.
  var main = root.querySelector('.js-ezl-main');
  var counter = root.querySelector('[data-ezl-count]');
  var thumbs = list('[data-ezl-thumb]');
  thumbs.forEach(function (thumb, index) {
    thumb.addEventListener('click', function () {
      if (!main) return;
      main.removeAttribute('srcset');
      main.removeAttribute('sizes');
      main.src = thumb.getAttribute('data-src');
      var full = root.querySelector('[data-ezl-full]');
      if (full) full.href = thumb.getAttribute('data-src').replace('width=1400', 'width=2400');
      main.alt = thumb.getAttribute('data-alt') || '';
      thumbs.forEach(function (other) { other.setAttribute('aria-current', other === thumb ? 'true' : 'false'); });
      if (counter) counter.textContent = (index + 1) + ' / ' + thumbs.length;
    });
  });

  // Options: each button is one purchasable version of the product.
  var dataEl = root.querySelector('[data-ezl-variants]');
  var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
  var idInput = root.querySelector('[data-ezl-variant-id]');
  var buyBox = root.querySelector('[data-ezl-buybox]');
  var soldBox = root.querySelector('[data-ezl-soldbox]');
  var sticky = document.querySelector('[data-ezl-sticky]');
  var options = list('[data-ezl-option]');

  function select(index) {
    var variant = variants[index];
    if (!variant) return;
    if (idInput) idInput.value = variant.id;
    list('[data-ezl-price-ex]', document).forEach(function (el) { el.textContent = variant.price; });
    list('[data-ezl-price-inc]', document).forEach(function (el) { el.textContent = variant.inc; });
    if (buyBox) buyBox.hidden = !variant.available;
    if (soldBox) soldBox.hidden = variant.available;
    if (sticky) sticky.hidden = !variant.available;
    options.forEach(function (option, i) { option.setAttribute('aria-pressed', i === index ? 'true' : 'false'); });
  }
  options.forEach(function (option, index) {
    option.addEventListener('click', function () { select(index); });
  });

  var purchase = root.querySelector('.ezl-buyform');
  if (sticky && purchase && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      sticky.classList.toggle('is-in-view', entries[0].isIntersecting);
    }, {threshold: 0}).observe(purchase);
  }

  // Quantity stepper.
  var qty = root.querySelector('[data-ezl-qty]');
  list('[data-ezl-qty-step]').forEach(function (button) {
    button.addEventListener('click', function () {
      var next = (parseInt(qty.value, 10) || 1) + parseInt(button.getAttribute('data-ezl-qty-step'), 10);
      qty.value = Math.max(1, Math.min(99, next));
    });
  });

  var desc = root.querySelector('[data-ezl-desc]');
  var tabs = root.querySelector('[data-ezl-tabs]');
  if (!desc) return;

  // Wording corrections applied to product descriptions, matching the previous storefront.
  // The lasting fix is to correct the description itself in Shopify admin.
  var corrections = [
    [/\b(?:2[- ]years?|two[- ]years?|24[- ]months?)\s+(?:manufacturer(?:'s)?\s+)?warrant(?:y|ies)\b/gi, '12-month warranty'],
    [/\b(?:manufacturer(?:'s)?\s+)?warrant(?:y|ies)\s*(?:of|for|:)?\s*(?:2[- ]years?|two[- ]years?|24[- ]months?)\b/gi, '12-month warranty'],
    [/\b12[ -]months?\s+warrant(?:y|ies)\b/gi, '12-month warranty']
  ];
  if (location.pathname.indexOf('/eezy-split-electric-folding-wheelchair') > -1) {
    var bootNote = 'Designed to suit most hatchback, estate and SUV boots. Always check the folded dimensions against your vehicle.';
    corrections = corrections.concat([
      [/\b(?:airline|IATA)[ -]?approved\b/gi, 'within IATA guidance — confirm with your airline before travelling'],
      [/\b(?:dual\s+)?10\s?Ah batter(?:y|ies)\b/gi, 'two 24V 6Ah lithium batteries'],
      [/\b288\s?Wh batteries?\b/gi, 'two removable 144Wh lithium batteries (288Wh combined)'],
      [/\b20\s*[–-]\s*25\s?km\b/gi, 'up to 25 km from a full charge'],
      [/\b12\.5\s?kg\b/gi, '19.2 kg with both batteries fitted'],
      [/\b(?:fits? (?:in|into) )?any car boot\b/gi, bootNote],
      [/\bno (?:ramp|vehicle hoist) needed\b/gi, 'A ramp or hoist may still be appropriate depending on lifting ability.']
    ]);
  }
  var walker = document.createTreeWalker(desc, NodeFilter.SHOW_TEXT);
  var textNode;
  while ((textNode = walker.nextNode())) {
    var original = textNode.nodeValue;
    var corrected = original;
    corrections.forEach(function (rule) { corrected = corrected.replace(rule[0], rule[1]); });
    if (corrected !== original) textNode.nodeValue = corrected;
  }

  // Description: split the product description into overview copy, key features and a specification sheet.
  if (!tabs) return;
  var squash = function (text) { return (text || '').replace(/\s+/g, ' ').trim(); };
  var buckets = { d: [], f: [], s: [] };
  var current = 'd';
  var level = 0;

  list(':scope > *', desc).forEach(function (el) {
    var tag = el.tagName.toLowerCase();
    var text = (el.textContent || '').trim();
    var lower = text.toLowerCase();
    if (tag === 'p' && !text.replace(/ |\s/g, '') && !el.querySelector('img,iframe,video')) return;
    var isHeading = /^h[1-4]$/.test(tag);
    var isBoldLabel = false;
    if (tag === 'p' && text.length < 60) {
      var strongs = el.querySelectorAll('strong, b');
      if (strongs.length === 1 && text.replace(/[\s:·•\-—]+$/g, '').length === strongs[0].textContent.trim().length) isBoldLabel = true;
    }
    if (isHeading || isBoldLabel) {
      var headingLevel = isHeading ? Number(tag.charAt(1)) : 7;
      if (current === 's' && isHeading && headingLevel > level) { buckets.s.push(el); return; }
      if (/feature|benefit|highlight/.test(lower)) { current = 'f'; level = headingLevel; return; }
      if (/spec|tech|dimension|battery & charg|performance/.test(lower)) { current = 's'; level = headingLevel; return; }
      if (isHeading) { current = 'd'; level = 0; }
    }
    buckets[current].push(el);
  });

  if (!buckets.f.length && !buckets.s.length) return;

  // Overview keeps the description copy.
  desc.innerHTML = '';
  buckets.d.forEach(function (el) { desc.appendChild(el); });

  // Key features become a ticked list in a panel.
  var featureItems = [];
  var featureRest = document.createElement('div');
  featureRest.className = 'ezl-rte';
  buckets.f.forEach(function (el) {
    var tag = el.tagName.toLowerCase();
    if (tag === 'ul' || tag === 'ol') {
      list(':scope > li', el).forEach(function (li) { if (li.innerHTML.trim()) featureItems.push(li.innerHTML.trim()); });
    } else {
      featureRest.appendChild(el);
    }
  });
  var slot = root.querySelector('[data-ezl-features]');
  if (slot) {
    if (featureRest.childNodes.length) slot.appendChild(featureRest);
    if (featureItems.length) {
      var box = document.createElement('div');
      box.className = 'ezl-features';
      var heading = document.createElement('h2');
      heading.textContent = 'Key features';
      var ul = document.createElement('ul');
      ul.setAttribute('role', 'list');
      featureItems.forEach(function (html) {
        var li = document.createElement('li');
        li.innerHTML = '<svg class="ezl-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg><span></span>';
        li.querySelector('span').innerHTML = html;
        ul.appendChild(li);
      });
      box.appendChild(heading);
      box.appendChild(ul);
      slot.appendChild(box);
    }
  }

  // Specifications become a ruled sheet, followed by what applies to every order.
  var sheet = root.querySelector('[data-ezl-sheet]');
  var note = root.querySelector('[data-ezl-sheet-note]');
  var specTab = root.querySelector('[data-ezl-tab="specs"]');
  var groups = [];
  var specRest = document.createElement('div');
  specRest.className = 'ezl-rte';
  var pendingHeading = null;
  var flush = function () { if (pendingHeading) specRest.appendChild(pendingHeading); pendingHeading = null; };
  buckets.s.forEach(function (el) {
    var tag = el.tagName.toLowerCase();
    if (/^h[1-6]$/.test(tag)) { flush(); pendingHeading = el; return; }
    if (tag === 'table') {
      var rows = list('tr', el).map(function (tr) {
        var cells = tr.querySelectorAll('th, td');
        var label = squash(cells[0] && cells[0].textContent);
        var value = squash(cells[1] && cells[1].textContent);
        return cells.length === 2 && label && value ? { label: label, value: value } : null;
      });
      if (rows.length && rows.every(function (row) { return row !== null; })) {
        groups.push({ heading: pendingHeading ? squash(pendingHeading.textContent) : null, rows: rows });
        pendingHeading = null;
        return;
      }
    }
    flush();
    specRest.appendChild(el);
  });
  flush();

  var hasSpecs = groups.length > 0 || specRest.childNodes.length > 0;
  if (hasSpecs && sheet) {
    var labels = [];
    var makeGroup = function (title) {
      var wrap = document.createElement('div');
      wrap.className = 'ezl-sheet__group';
      if (title) { var h3 = document.createElement('h3'); h3.textContent = title; wrap.appendChild(h3); }
      var dl = document.createElement('dl');
      wrap.appendChild(dl);
      sheet.appendChild(wrap);
      return dl;
    };
    var lastList = null;
    groups.forEach(function (group) {
      lastList = makeGroup(group.heading);
      group.rows.forEach(function (row) {
        labels.push(row.label.toLowerCase());
        var div = document.createElement('div');
        var dt = document.createElement('dt');
        var dd = document.createElement('dd');
        dt.textContent = row.label;
        dd.textContent = row.value;
        div.appendChild(dt);
        div.appendChild(dd);
        lastList.appendChild(div);
      });
    });
    var template = root.querySelector('[data-ezl-order-rows]');
    if (template && groups.length) {
      var listsWarranty = labels.some(function (label) { return label.indexOf('warranty') > -1; });
      var target = groups.length === 1 && !groups[0].heading ? lastList : makeGroup('Delivery, VAT relief and warranty');
      list('div', template.content.cloneNode(true)).forEach(function (row) {
        if (listsWarranty && row.hasAttribute('data-warranty')) return;
        target.appendChild(row);
      });
    }
    if (specRest.childNodes.length) sheet.parentNode.insertBefore(specRest, note);
    if (note) {
      var listsRange = labels.some(function (label) { return label.indexOf('range') > -1; });
      note.textContent = 'Figures from the current product listing.' + (listsRange ? ' Range varies with user weight, terrain and temperature.' : '');
    }
    if (specTab) specTab.hidden = false;
  }

  // Tabs.
  var tabButtons = list('[data-ezl-tab]');
  function show(name, focus) {
    tabButtons.forEach(function (button) {
      var active = button.getAttribute('data-ezl-tab') === name;
      button.setAttribute('aria-selected', active ? 'true' : 'false');
      button.setAttribute('tabindex', active ? '0' : '-1');
      var panel = document.getElementById(button.getAttribute('aria-controls'));
      if (panel) panel.hidden = !active;
      if (active && focus) button.focus();
    });
  }
  tabButtons.forEach(function (button) {
    button.addEventListener('click', function () { show(button.getAttribute('data-ezl-tab'), false); });
    button.addEventListener('keydown', function (event) {
      if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
      var visible = tabButtons.filter(function (b) { return !b.hidden; });
      var next = visible[(visible.indexOf(button) + (event.key === 'ArrowRight' ? 1 : visible.length - 1)) % visible.length];
      if (next) show(next.getAttribute('data-ezl-tab'), true);
    });
  });
  tabs.hidden = false;
  show('overview', false);
})();
